/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lead_Converted_AtInputs */

const cs_lead_converted_at = /** @type {(inputs: Lead_Converted_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Převod`)
};

const en_lead_converted_at = /** @type {(inputs: Lead_Converted_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converted`)
};

/**
* | output |
* | --- |
* | "Converted" |
*
* @param {Lead_Converted_AtInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lead_converted_at = /** @type {((inputs?: Lead_Converted_AtInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lead_Converted_AtInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lead_converted_at(inputs)
	return cs_lead_converted_at(inputs)
});